/**
 * footprint = 모듈이 그리드에서 점유하는 셀 모양 (지시문 후속 — 슬롯 다중 점유).
 * anchor 셀(offset {0,0}) 기준 offset 리스트로 점유 셀을 파생한다. 인스턴스 획득 시 랜덤 배정.
 *
 * 포트/라우팅 규약:
 *  - single(1×1): 기존 shapeId(MODULE_DEFAULT_SHAPE) 포트를 그대로 쓴다(기존 퍼즐 보존).
 *  - 다중 셀(vert2/horz2): 셀별 포트는 modulePorts.ts cellPortsForPlaced가 모양 보존 합성
 *    (straight→footprint 방향 직선 / corner·t→꺾임·분기 보존 / cross→4방향). 점유 셀 간 연결은 항상 포함해 라우팅 끊김 방지.
 */
export type FootprintId = "single" | "vert2" | "horz2";

export interface CellOffset {
  readonly dx: number;
  readonly dy: number;
}

export interface FootprintDef {
  readonly id: FootprintId;
  readonly displayName: string;
  /** rotation 0 기준 점유 offset (anchor 포함 = {0,0}). */
  readonly cells: readonly CellOffset[];
}

/** MVP 3종. single(1칸) / vert2(세로2) / horz2(가로2). L/2×2는 후속. */
export const FOOTPRINT_CATALOG: Record<FootprintId, FootprintDef> = {
  single: { id: "single", displayName: "1칸", cells: [{ dx: 0, dy: 0 }] },
  vert2: { id: "vert2", displayName: "세로2", cells: [{ dx: 0, dy: 0 }, { dx: 0, dy: 1 }] },
  horz2: { id: "horz2", displayName: "가로2", cells: [{ dx: 0, dy: 0 }, { dx: 1, dy: 0 }] },
};

/** 추첨/순회 순서 고정 (결정론). */
export const FOOTPRINT_IDS: readonly FootprintId[] = ["single", "vert2", "horz2"];

export function footprintDef(id: string): FootprintDef {
  return FOOTPRINT_CATALOG[id as FootprintId] ?? FOOTPRINT_CATALOG.single;
}

export function isSingleFootprint(id: string): boolean {
  return footprintDef(id).id === "single";
}

/** footprint 점유 셀 (anchor 기준 offset). 회전 제거 — footprint는 고정 모양(vert2=세로, horz2=가로). */
export function footprintCells(footprintId: string): readonly CellOffset[] {
  return footprintDef(footprintId).cells;
}
